var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { getNested, getOptions, formatFindedString } from '../autocomplete.helpers';
export function useListFilter(state, props) {
    var searchText = React.useRef('');
    var options = props.options, optionsAsync = props.optionsAsync, filterKey = props.filterKey;
    var _a = React.useState(false), initialized = _a[0], setInitialized = _a[1];
    var _b = React.useState(Array.isArray(options) ? options : []), completeOptions = _b[0], setCompleteOptions = _b[1];
    var _c = React.useState(Array.isArray(options) ? options : []), filteredOptions = _c[0], setFilteredOptions = _c[1];
    function filter(event) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data, items;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setInitialized(true);
                        searchText.current = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                        if (!searchText.current) return [3 /*break*/, 4];
                        if (!(typeof optionsAsync === 'function')) return [3 /*break*/, 2];
                        state.setLoading(true);
                        return [4 /*yield*/, optionsAsync(searchText.current)];
                    case 1:
                        data = _b.sent();
                        setFilteredOptions(getOptions(data));
                        state.setLoading(false);
                        return [3 /*break*/, 3];
                    case 2:
                        if (completeOptions === null || completeOptions === void 0 ? void 0 : completeOptions.length) {
                            items = __spreadArray([], completeOptions, true);
                            if (typeof items[0] === 'string') {
                                if (typeof filterKey === 'function') {
                                    items = items.filter(filterKey);
                                }
                                else {
                                    items = items.filter(function (option) { var _a; return (_a = option.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(searchText.current); });
                                }
                            }
                            else if (typeof items[0] === 'object') {
                                if (typeof filterKey === 'function') {
                                    items = items.filter(filterKey);
                                }
                                else if (Array.isArray(filterKey)) {
                                    items = items.filter(function (option) { return filterKey.some(function (key) { var _a; return (_a = getNested(key, option)) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.current); }); });
                                }
                                else if (typeof filterKey === 'string') {
                                    items = items.filter(function (option) { var _a; return (_a = getNested(filterKey, option).toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(searchText.current); });
                                }
                            }
                            setFilteredOptions(items);
                        }
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        setFilteredOptions(__spreadArray([], completeOptions, true));
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function search() {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof options === 'function')) return [3 /*break*/, 5];
                        data = [];
                        state.setLoading(true);
                        if (!(typeof options['getOptions'] === 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, options['getOptions']()];
                    case 1:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, options()];
                    case 3:
                        data = _a.sent();
                        _a.label = 4;
                    case 4:
                        setCompleteOptions(getOptions(data));
                        setFilteredOptions(getOptions(data));
                        setInitialized(true);
                        state.setLoading(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function clear() {
        searchText.current = '';
        if (typeof optionsAsync !== 'function')
            setFilteredOptions(__spreadArray([], completeOptions, true));
    }
    React.useEffect(function () {
        search();
    }, []);
    return {
        options: filteredOptions,
        initialized: initialized,
        clear: clear,
        onChange: filter,
        format: function (text, options) { return formatFindedString(searchText.current, text, options); }
    };
}
